// extracted by mini-css-extract-plugin
export var statItem = "_eq-1";
export var statsRow = "_eq-0";